const trimEmail = (val) => (val && val.trim ? val.trim() : val);
export default trimEmail;
